// WebSocketContext.tsx
import React, { useContext, useEffect, useMemo } from 'react';

import config from '../../config/config';
import getFirstSubdomain from '../../shared-functions/DomainsplitFunction';
import webSocketService from '../../websocket/wsService';
import { useBranding } from '../BrandingContext';

import WebSocketContext from './WebSocketContext';

/**
 * Web socket provider
 * @param {any} param0 - The param0
 * @param {any} param0.children - The children prop
 * @returns {any} The result
 */
export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const { brandData } = useBranding();
  const domain = getFirstSubdomain();
  console.log(domain, 'domain');
  useEffect(() => {
    // Connect to WebSocket
    const socketUrl = `${domain && brandData?.webSocketUrl ? brandData?.webSocketUrl : config.websocketUrl}/end-consumer?mode=guest&anyUser=superAdminCommands`;
    webSocketService.connect(socketUrl);

    return () => {
      // Disconnect WebSocket on cleanup
      webSocketService.disconnect();
    };
  }, []);

  // Use useMemo to prevent unnecessary re-renders
  const contextValue = useMemo(
    () => ({
      webSocketService,
    }),
    [webSocketService],
  );

  return <WebSocketContext.Provider value={contextValue}>{children}</WebSocketContext.Provider>;
}

/**
 * Use websocket context
 * @returns {any} The result
 */
export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    console.warn('useWebSocket must be used within a WebSocketProvider');
  }
  return context;
};
